import React from "react";
import { Col, Image, Row } from "react-bootstrap";
import AllHeader from "../../components/AllHeader";
import Parent from "../../container/Parent";
import { useLocation } from "react-router-dom";
import imagefile from "../../assets/img/picture-file1.png";
import differentfile from "../../assets/img/file.png";

const ViewFile = () => {
  const location = useLocation();
  const { filesList } = location.state || {};

  return (
    <div className="py-5">
      <AllHeader>
        <span>مشاهده فایل</span>
      </AllHeader>
      <Parent>
        <Row className="justify-content-start justify-content-lg-center py-4 gy-3">
          {filesList?.map((data, index) => {
            const pasvandFile = data.fileName.split(".").pop().toLowerCase(); //برای گرفتن فرمت عکس از انتهای آدرس 
            const imgPasvandha = ["jpg", "jpeg", "png", "gif", "bmp", "svg"];
            const isImage = imgPasvandha.includes(pasvandFile);
            return (
              <Col xs={6} md={3} lg={3} xl={2} className="text-center" key={index}>
                <div className="file-container">
                  <Image src={isImage ? imagefile : differentfile} alt="" />
                  <div className="file-content mt-3 mt-lg-2 mt-xl-0">
                    <h6>{data.title}</h6>
                  <a
                    href={"http://192.168.100.55:7016" + data.fileName}
                    alt="imageFile"
                    target="_blank"
                    class="btn btn-info text-white"
                    role="button"
                  >
                    {isImage ? (
                      <span>دانلود عکس</span>
                    ) : (
                      <span>دانلود فایل</span>
                    )}
                  </a>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </Parent>
    </div>
  );
};

export default ViewFile;
